const AppDimension = {
  notificationMarqueeHeight: 30,
};

export default AppDimension;
